import { CustomContentSection } from 'common/modules/customization';
import { ById, TranslatableField, LocaleField } from 'common/types';
import { TFunction } from 'react-i18next';

export const customContentTranslatableFields = (
	fields: ById<TranslatableField>,
	args: {
		id: string;
		label: string;
		value: LocaleField;
		type: string;
		shopId: string;
		storeId: string;
		sectionIndex: number;
		contentIndex: number;
	},
) => {
	const { id, label, value, type, shopId, storeId, sectionIndex, contentIndex } = args;
	fields[id] = {
		id,
		label,
		value,
		opts: {
			type: type as any,
			args: {
				shopId,
				storeId,
				sectionIndex,
				contentIndex,
			},
		},
	};
};

export const customContentTranslations = (
	sections: CustomContentSection[],
	fields: ById<TranslatableField>,
	shopId: string,
	storeId: string,
	t: TFunction,
) => {
	sections.forEach((section, sectionIndex) => {
		const content = section.content;
		if (!!content) {
			content.forEach((content, contentIndex) => {
				switch (content?.type) {
					case 'image':
						if (!!content.heading?.def) {
							customContentTranslatableFields(fields, {
								id: `aboutSettings.customImage.${contentIndex}.image.heading`,
								label: t('translations.fields.about.customContent.heading', {
									sectionIdx: sectionIndex + 1,
									contentIdx: contentIndex + 1,
									defaultValue:
										'About page, section {{sectionIdx}}, custom content {{contentIdx}}, heading',
								}),
								value: content.heading,
								type: 'aboutCustomImageHeading',
								shopId,
								storeId,
								sectionIndex,
								contentIndex,
							});
						}
						if (!!content.description?.def) {
							customContentTranslatableFields(fields, {
								id: `aboutSettings.customImage.${contentIndex}.image.description`,
								label: t('translations.fields.about.customContent.body', {
									sectionIdx: sectionIndex + 1,
									contentIdx: contentIndex + 1,
									defaultValue:
										'About page, section {{sectionIdx}}, custom content {{contentIdx}}, body',
								}),
								value: content.description,
								type: 'aboutCustomImageDescription',
								shopId,
								storeId,
								sectionIndex,
								contentIndex,
							});
						}
						break;
					case 'text':
						if (!!content.heading?.def) {
							customContentTranslatableFields(fields, {
								id: `aboutSettings.customText.${contentIndex}.text.heading`,
								label: t('translations.fields.about.customContent.heading', {
									sectionIdx: sectionIndex + 1,
									contentIdx: contentIndex + 1,
									defaultValue:
										'About page, section {{sectionIdx}}, custom content {{contentIdx}}, heading',
								}),
								value: content.heading,
								type: 'aboutCustomTextHeading',
								shopId,
								storeId,
								sectionIndex,
								contentIndex,
							});
						}
						if (!!content.body?.def) {
							customContentTranslatableFields(fields, {
								id: `aboutSettings.customText.${contentIndex}.text.body`,
								label: t('translations.fields.about.customContent.body', {
									sectionIdx: sectionIndex + 1,
									contentIdx: contentIndex + 1,
									defaultValue:
										'About page, section {{sectionIdx}}, custom content {{contentIdx}}, body',
								}),
								value: content.body,
								type: 'aboutCustomTextBody',
								shopId,
								storeId,
								sectionIndex,
								contentIndex,
							});
						}
						break;
				}
			});
		}
	});
};
